/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useQuery,gql } from '@apollo/client';
import {  handleApolloError } from '@exo/frontend-common-apollo';

export const useMaintenance = (inputKeys, skipCondition) => {
  const MAINTENANCE = gql`
    query ($inputKeys: [String!]!) {
        configuration(inputKeys: $inputKeys) {
          name
          value    
        }
      }
`;
  const variables = {"inputKeys":inputKeys}

  const { loading, error, data } = useQuery(MAINTENANCE, { variables, skip : skipCondition,context:{clientName:"config"} });
  handleApolloError(__filename, error);

  //return { called, loading, data: transformResponse(data), error };
  return { maintenanceError:error, maintenanceloading:loading, maintenanceData: data ?? [] };
};
